module.exports = __webpack_public_path__ + "img/capa1.0d6a16d7.jpg";